export default __webpack_public_path__ + "static/media/ProximaNova-Regular.83ea8f85.woff2";